export default __webpack_public_path__ + "static/media/timor.ace09158.md";